import { render, staticRenderFns } from "./ESGCalculator.vue?vue&type=template&id=45141181&scoped=true&"
import script from "./ESGCalculator.vue?vue&type=script&lang=js&"
export * from "./ESGCalculator.vue?vue&type=script&lang=js&"
import style0 from "./ESGCalculator.vue?vue&type=style&index=0&id=45141181&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45141181",
  null
  
)

export default component.exports